module.exports = __webpack_public_path__ + "static/media/halloweenHD.5c2a27a6.mp4";